/* Inbox Chat Control v3
   Keeps the Shopify Inbox bubble hidden until a #open-chat link is clicked,
   then shows it for the rest of the browser session and keeps it behind the
   cart drawer. Visibility itself is driven by the CSS rule in
   snippets/doc-head-core.liquid, which hides the chat UNLESS <html> carries
   the qa-chat-on class. That way, if Shopify renames the element again the
   bubble stays hidden rather than showing to every customer.
   Shopify renamed the element to <inbox-online-store-chat> around Jul 2026
   (usually two per page); the older names are kept in the list too. */
(function () {
  var SS_SHOW_KEY = 'qa_inbox_show_launcher_session';
  var HOST_SELECTOR = 'inbox-online-store-chat, #ShopifyChat, #shopify-chat, shopify-chat, [id*="shopify-chat" i]';

  function findHosts() {
    return Array.prototype.slice.call(document.querySelectorAll(HOST_SELECTOR));
  }

  function wantShow() {
    try { return sessionStorage.getItem(SS_SHOW_KEY) === '1'; } catch (e) { return false; }
  }

  function applyClass() {
    if (wantShow()) { document.documentElement.classList.add('qa-chat-on'); }
    else { document.documentElement.classList.remove('qa-chat-on'); }
  }

  function keepChatBehindCart(host) {
    var cartOpen =
      document.querySelector('cart-drawer[open]') ||
      document.querySelector('#CartDrawer.is-open') ||
      document.querySelector('#CartDrawer.active') ||
      document.querySelector('.cart-drawer.active') ||
      document.querySelector('.drawer--active') ||
      document.querySelector('.drawer.is-open') ||
      document.querySelector('body.js-drawer-open') ||
      document.querySelector('body.cart-drawer-open');

    host.style.zIndex = cartOpen ? '1' : '2147483640';
  }

  function tryAutoOpen(host) {
    // Best effort: click the launcher so the panel opens rather than just the
    // bubble appearing. Loose selector list on purpose. If none match, the
    // bubble is still visible and clickable, so nothing breaks. Shadow root
    // first, then plain markup, since the current build renders the toggle in
    // the light DOM.
    var scopes = [];
    if (host.shadowRoot) { scopes.push(host.shadowRoot); }
    scopes.push(host);

    for (var i = 0; i < scopes.length; i++) {
      var toggle = scopes[i].querySelector(
        '.chat-toggle, [data-spec="button-icon"], .launcher, button.toggle, [data-chat-toggle], button[aria-label*="chat" i], button'
      );
      if (toggle) { toggle.click(); return; }
    }
  }

  function activate() {
    try { sessionStorage.setItem(SS_SHOW_KEY, '1'); } catch (e) {}
    applyClass();

    var tries = 0;
    var id = setInterval(function () {
      findHosts().forEach(tryAutoOpen);
      if (++tries > 20) { clearInterval(id); }
    }, 250);
  }

  function delegateOpeners() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('a[href], [data-open-chat], #open-chat');
      if (!opener) return;

      var isLink = opener.matches('a[href]');
      var href = isLink ? (opener.getAttribute('href') || '') : '';

      var isTrigger =
        href.indexOf('#open-chat') > -1 ||
        href.indexOf('openChat=1') > -1 ||
        opener.id === 'open-chat' ||
        opener.hasAttribute('data-open-chat');

      if (!isTrigger) return;

      e.preventDefault();
      activate();
    });
  }

  function applyState() {
    applyClass();
    if (!wantShow()) return; /* bubble is hidden by CSS; no need to scan the page */
    findHosts().forEach(keepChatBehindCart);
  }

  function init() {
    delegateOpeners();
    applyState();

    document.addEventListener('shopify:section:load', applyState);

    setTimeout(applyState, 1000);
    setInterval(applyState, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();